export default [
    {
        text: 'Full Name',
        value: 'fullName',
        order: 0,
        sortable: true,
        hidable: false,
        hidden: false,
    },
    {
        text: 'Email',
        value: 'email',
        sortable: false,
        order: 1,
        hidable: true,
        hidden: false,
    },
    {
        text: 'Actions',
        value: 'actions',
        align: 'right',
        sortable: false,
        order: 2,
        hidable: true,
        hidden: false,
        width: '92px',
    },
];
